module.exports = __webpack_public_path__ + "img/arrow.b36a4835.svg";